module.exports = __webpack_public_path__ + "assets/img/guide.a51984ed.jpg";